import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgStyle } from '@angular/common';
import { Tooltip } from 'primeng/tooltip';
import { ExtractedRow } from '../../../../../models/extracted-values';
import { TooltipDirective } from '@vydaps/gui-commons';

@Component({
  selector: 'ct-extraction-edit-table-layout',
  imports: [NgStyle, Tooltip, TooltipDirective],
  templateUrl: './edit-table-layout.component.html',
  styleUrl: './edit-table-layout.component.css',
})
export class EditTableLayoutComponent {
  @Input({ required: true }) topAndBottomAddLineControls!: boolean;
  @Input({ required: true }) rowIndex!: number;
  @Input({ required: true }) row!: ExtractedRow;

  @Output() deleteRowAtIndex = new EventEmitter<number>();
  @Output() rowAdded = new EventEmitter<{ index: number; row: ExtractedRow }>();
}
